import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
	selector: 'amd-confirm-action-dialog',
	templateUrl: './confirm-action.component.html',
	styleUrls: ['./confirm-action.component.scss']
})
export class ConfirmActionComponent {

	dialog_data: ConfirmActionDialogData;
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: ConfirmActionDialogData,
		public dialogRef: MatDialogRef<ConfirmActionComponent>
	) {
		this.dialog_data = data;
	}
}


export interface ConfirmActionDialogData {
	message: string;
	confirm_text: string;
	abort_text: string;
	title_text?: string;
}
